import { render, staticRenderFns } from "./DocumentsComposite.vue?vue&type=template&id=588fc7bf"
import script from "./DocumentsComposite.vue?vue&type=script&lang=ts"
export * from "./DocumentsComposite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports